import { ChevronDown } from "lucide-react";

const HERO_IMAGE = "/images/artist-hero.jpg";

export const HeroSection = ({ onBookNow }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />

      {/* Dark overlays */}
      <div className="absolute inset-0 bg-[#050505]/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/50 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end max-w-7xl mx-auto px-6 md:px-12 pb-24 md:pb-32">
        {/* Gold line accent */}
        <div className="gold-line mb-8 opacity-0 animate-fade-in stagger-1" />

        <p className="font-sub text-[10px] md:text-xs text-white/40 tracking-[0.3em] mb-4 opacity-0 animate-fade-in-up stagger-2">
          TORONTO — MUSIC PRODUCER & DJ
        </p>

        <h1 className="opacity-0 animate-fade-in-up stagger-3 mb-6">
          <img
            src="/images/alchemist-logo.png"
            alt="Alchemist (CA)"
            className="h-24 sm:h-32 md:h-40 lg:h-52 w-auto"
          />
        </h1>

        <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mt-4 opacity-0 animate-fade-in-up stagger-4">
          <button
            data-testid="book-now-btn"
            onClick={onBookNow}
            className="btn-alchemist border border-white/25 bg-white/5 hover:bg-white hover:text-black py-4 px-10 uppercase tracking-widest text-xs font-sub transition-colors duration-300"
          >
            Book Now
          </button>
          <a
            href="#events"
            data-testid="upcoming-events-link"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#events")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="font-sub text-xs text-white/40 hover:text-white tracking-widest transition-colors duration-300 py-4 underline-offset-4 hover:underline"
          >
            Upcoming Events
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 opacity-0 animate-fade-in stagger-5">
        <ChevronDown className="w-5 h-5 text-white/20 animate-bounce" />
      </div>
    </section>
  );
};
